/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// May contain unused imports in some cases
// @ts-ignore
import { MoneyFlowGameCriteriaDto } from "./money-flow-game-criteria-dto";
// May contain unused imports in some cases
// @ts-ignore
import { MoneyFlowPlayerCriteriaDto } from "./money-flow-player-criteria-dto";

/**
 *
 * @export
 * @interface MoneyFlowRequestDto
 */
export interface MoneyFlowRequestDto {
  /**
   *
   * @type {MoneyFlowGameCriteriaDto}
   * @memberof MoneyFlowRequestDto
   */
  game_criteria: MoneyFlowGameCriteriaDto;
  /**
   *
   * @type {MoneyFlowPlayerCriteriaDto}
   * @memberof MoneyFlowRequestDto
   */
  hero_criteria: MoneyFlowPlayerCriteriaDto;
  /**
   *
   * @type {MoneyFlowPlayerCriteriaDto}
   * @memberof MoneyFlowRequestDto
   */
  opponent_criteria: MoneyFlowPlayerCriteriaDto;
  /**
   *
   * @type {string}
   * @memberof MoneyFlowRequestDto
   */
  period: MoneyFlowRequestDtoPeriodEnum;
  /**
   *
   * @type {Array<MoneyFlowPlayerCriteriaDto>}
   * @memberof MoneyFlowRequestDto
   */
  sub_opponents_criteria: Array<MoneyFlowPlayerCriteriaDto>;
}

export const MoneyFlowRequestDtoPeriodEnum = {
  Day: "DAY",
  Week: "WEEK",
  Decade: "DECADE",
} as const;

export type MoneyFlowRequestDtoPeriodEnum =
  (typeof MoneyFlowRequestDtoPeriodEnum)[keyof typeof MoneyFlowRequestDtoPeriodEnum];
